import { Component, Input } from '@angular/core';
import { NotAvailablePipe } from '@shared/pipes';

@Component({
  selector: 'app-details-item',
  templateUrl: './details-item.component.html',
  standalone: true,
  imports: [NotAvailablePipe],
})
export class DetailsItemComponent {
  @Input() label = '';

  @Input() value?: string | null;
}
